import { createContext, Dispatch, SetStateAction } from 'react';

import { noop } from '@/utils/noop';

export type Question = {
  questionId: string;
  answersIds: Set<string>;
};

type QuizViewContextState = {
  learningActivityId: number;
  answeredQuestions: Question[];
  submitted: boolean;
  setAnsweredQuestions: Dispatch<SetStateAction<Question[]>>;
  refetch: () => void;
  retakeModalOpen: boolean;
  setRetakeModalOpen: Dispatch<SetStateAction<boolean>>;
};

export const QuizViewContext = createContext<QuizViewContextState>({
  learningActivityId: 0,
  answeredQuestions: [],
  submitted: false,
  setAnsweredQuestions: noop,
  refetch: noop,
  retakeModalOpen: false,
  setRetakeModalOpen: noop,
});
